import ReactECharts from "echarts-for-react";
import { EChartsOption as IOptions } from "echarts-for-react";

interface IProps {
  options: IOptions;
}

const EchartGraph = ({ options }: IProps) => {
  return (
    <ReactECharts
      option={options}
      notMerge={true}
      style={{ height: "100%", width: "100%", minHeight: 280 }}
      opts={{ renderer: "canvas" }}
    />
  );
};

export default EchartGraph;
